module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Bold.8e4c4a88.otf";